// eslint-disable-next-line import/prefer-default-export
export const MAX_RECENT_FILES = 5;
export const MAX_RECENT_FILES_FOR_INVESTORS = 10;
